export default {
  'statements.editSettings': 'Edit Statement Settings',
  'statements.header': 'Statements and Reports',
  'statements.period': 'Statement Period',
  'statements.maxLength': 'You can only select <%=maxLength %> accounts at a time.',
  'statements.partialResult':
    'Partial result. One or more Statements within your request is not found.',
  'statements.maxRange': 'Maximum range is <%=months + 1 %> months'
};
